import React, { useState, createContext, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./home/Home.jsx";
import Form from "./form/Form.jsx";
import Confirm from "./form/Confirm.jsx";
import Thanks from "./form/Thanks.jsx";
import Page404 from "./common/Page404.jsx";

// 共有変数の格納先を生成
export const Data = createContext();

export default function App() {
  const [rawList, setRawList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [detailList, setDetailList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalCurrent, setModalCurrent] = useState({});
  const [sofaList, setSofaList] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    furigana1: "",
    furigana2: "",
    post: "",
    pref: "",
    address1: "",
    address2: "",
    email: "",
    emailcheck: "",
    enquate1: "",
    enquate2: "",
    enquate3: "",
    enquate4: "",
    enquate5: "",
    message: "",
    mm: "希望する",
    kijiname: [],
  });
  const [errors, setErrors] = useState({
    name: "",
    lastname: "",
    furigana1: "",
    furigana2: "",
    post: "",
    pref: "",
    address1: "",
    address2: "",
    email: "",
    emailcheck: "",
    message: null,
  });

  // 共有変数を格納
  const value = {
    rawList, // 全生地のリスト
    filteredList, // 絞り込み後のリスト
    setFilteredList, // 絞り込み後のリストの更新用関数
    detailList, // シリーズ詳細リスト
    selectedList, // 選択中の生地(5枚まで)
    setSelectedList, // 請求生地登録用関数
    modal, // モーダル表示状態(true/false)
    setModal, // モーダル表示切り替え用関数
    modalCurrent, // モーダル内選択生地
    setModalCurrent, // モーダル内生地の更新用関数
    formData, //フォーム入力情報
    setFormData, //フォーム入力情報更新用関数
    errors, //フォームのエラーメッセージ
    setErrors, //フォームのエラー更新用関数
    sofaList, //検討ソファ用リスト
  };

  // 初回データ取得
  useEffect(() => {
    // nydb_kijiから生地の一覧を取得
    fetch("/api/material.php?type=list", { cache: "no-cache" })
      .then((res) => res.json())
      .then((data) => setRawList(data))
      .catch((err) => console.error(err));

    // nydb_clothから生地シリーズの一覧を取得
    fetch("/api/material.php?type=detail")
      .then((res) => res.json())
      .then((data) => setDetailList(data))
      .catch((err) => console.error(err));

    // 検討ソファ用シリーズ名一覧を取得
    fetch("/api/sofadata.php?type=series")
      .then((res) => res.json())
      .then((data) => setSofaList(data));

    return () => {
      setRawList(null);
      setFilteredList(null);
      setDetailList(null);
      setModal(null);
      setModalCurrent(null);
    };
  }, []);

  return (
    <>
      <React.StrictMode>
        <Data.Provider value={value}>
          <BrowserRouter basename="/material">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/form" element={<Navigate to="/form/" />} />
              <Route path="/form/" element={<Form />} />
              <Route
                path="/form/thanks"
                element={<Navigate to="/form/thanks/" />}
              />
              <Route path="/form/thanks/" element={<Thanks />} />
              <Route
                path="/form/confirm"
                element={<Navigate to="/form/confirm/" />}
              />
              <Route path="/form/confirm/" element={<Confirm />} />
              <Route path="*" element={<Page404 />} />
            </Routes>
          </BrowserRouter>
        </Data.Provider>
      </React.StrictMode>
    </>
  );
}
